import {
  BloodPressureObservation,
  BloodPressureObservationDto,
  toBloodPressureObservation,
} from "./BloodPressureObservation";

type BloodPressureObservations = {
  observations: BloodPressureObservation[];
};

export type BloodPressureObservationsDto = {
  observations: BloodPressureObservationDto[];
};

export const toBloodPressureObservations = (
  dto: BloodPressureObservationsDto
): BloodPressureObservations => ({
  observations: dto.observations.map((dto) => toBloodPressureObservation(dto)),
});

export default BloodPressureObservations;
